import { CUSTOMER_JOURNEY_EVENTS_CATEGORIES_ERROR } from './../const';

function action(errorCallback) {
  return { type: CUSTOMER_JOURNEY_EVENTS_CATEGORIES_ERROR, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyEventsCategoriesError.js